import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const FurnaceInstallationPage = () => <ServicePageTemplate data={seoPageData['furnace-installation']} />;
export default FurnaceInstallationPage;
